import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { IntlProvider, Text, Localizer, withText } from 'preact-i18n';
import util from 'preact-util';

class Blank extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        const { diagnoses = [] } = this.props;
        if (!diagnoses.length) {
            return null;
        }
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                {diagnoses.map(diagnosis => {
                    const fields = ['name', 'description', 'createdAt', 'createdBy'];
                    return (
                        <div className='d-flex flex-column mb-2' key={diagnosis.id}>
                            <div class='d-flex flex-row'>
                                <span class='font-weight-lighter'>Code:</span> {diagnosis.diagnoseCode}
                            </div>
                            <div class='d-flex flex-row'>
                                <span class='font-weight-lighter'>Diagnose:</span> {diagnosis.name}
                                {!!diagnosis.differential && <span class='badge text-bg-warning ms-1' title='Differensialdiagnose'><Text id='dyrejournal.diagnose-differential-short'>DD</Text></span>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>);
    }
}

export default Blank;